import { CELL_FILTER } from '@app/shared/types';
import { I18n } from '../strings-keys';
import {
  XuxDatePickerStaticTextContent,
  XuxDateTimePickerStaticTextContent,
} from './form-widget.staticTextContent.constants';

export const GridFilterDropDownStaticContent = Object.freeze({
  reset: I18n.Common.Reset,
  apply: I18n.Common.Apply,
  dmGridFilterDropdownSearchField: Object.freeze({
    searchMore: I18n.Common.SearchMore,
  }),
});

export const GridFilterEnumStaticContent = Object.freeze({
  noItemsToDisplay: I18n.Common.NoItemsToDisplay,
  selectAll: I18n.Common.SelectAll,
  dmGridFilterDropdown: GridFilterDropDownStaticContent,
});

export const GridFilterStringStaticContent = Object.freeze({
  dmGridFilterDropdown: GridFilterDropDownStaticContent,
});

export const GridFilterDateStaticContent = Object.freeze({
  dmGridFilterDropdown: GridFilterDropDownStaticContent,
  xuxDatepickerInput: XuxDatePickerStaticTextContent.xuxDatepickerInput,
});

export const GridFilterEntityStaticContent = Object.freeze({
  dmGridFilterDropdown: GridFilterDropDownStaticContent,
  noItems: I18n.Common.NoItemsToDisplayUpper,
  selectAll: I18n.Common.SelectAll,
});

/**
 * Static text content for grid filters.
 * You can add more filter types as needed.
 * Will automatically be used to translate when translating grid
 */
export const GRID_FILTERS_STATIC_TEXT_CONTENT = Object.freeze({
  [CELL_FILTER.enum]: GridFilterEnumStaticContent,
  [CELL_FILTER.string]: GridFilterStringStaticContent,
  [CELL_FILTER.date]: GridFilterDateStaticContent,
  [CELL_FILTER.entity]: GridFilterEntityStaticContent,
  [CELL_FILTER.dateLocale]: GridFilterDateStaticContent,
  [CELL_FILTER.dateTime]: {
    ...GridFilterDateStaticContent,
    xuxTimePicker: XuxDateTimePickerStaticTextContent.xuxTimePicker,
  },
});
